/*
 * Copyright (c) 2024, King Living
 * Resolve Contentful Link entry URLs to PWA app paths.
 */

import {urlHelper} from '@amblique/base/app/helpers/url-helper';

/**
 * Resolve a Contentful Link entry URL for use with storefront Link `to`/`href`.
 * Mirrors internal URL handling in contentful/models/link.jsx.
 *
 * @param {Contentful.Link|null|undefined} link
 * @returns {string|null}
 */
export function resolveContentfulLinkUrl(link) {
  const url = link?.url;

  if (!url || typeof url !== 'string') {
    return null;
  }

  const isExternal =
    url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//');
  const isHashOnly = url.startsWith('#');

  if (isExternal || isHashOnly) {
    return url;
  }

  const parsed = urlHelper.parseStorefrontUrl(url);

  return parsed?.appUrl || url;
}
